import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvLightContainer";
/**
 * A light container component
 */
let LvLightContainer = class LvLightContainer extends UIComponent {
};
LvLightContainer = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvLightContainer);
export default LvLightContainer;
//# sourceMappingURL=script.js.map